/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngLrjData', NgLrjData);

  NgLrjData.$inject = [
    '$rootScope',
    'LongPollingService',
    'LRJ_MANAGER'
  ];

  /* jscs:disable disallowFunctionDeclarations*/
  function NgLrjData($rootScope, longPolling, LRJ_MANAGER){
    var dir = {
      templateUrl: 'app/views/common/directives/longRunningJob/lrj-directive.html',
      controller: Controller,
      controllerAs: 'lrjCtrl',
      link: link,
      bindToController: true,
      scope: {
        close: '&',
        jobId: '=',
        statusPage: '=',
        type: '='
      }
    };

    return dir;

    function Controller(){
      var _this = this;
      var _triggerEvent = false;
      _this.status = {};
      _this.showLoading = true;
      _this.messageCancel = ['This Process was Cancelled'];
      _this.glue = true;
      _activate();

      /** methods */
      _this.imageProcess = _imageProcess;

      /** @private */
      function _activate(){
        if(!_this.jobId){
          return;
        }

        longPolling
          .params([{JobId: _this.jobId, IncludeChildren: true}])
          .start(_showProgress);
      }

      /** @private */
      function _processStatusPage(data){
        var status = data.Status;
        var jobType = data.Command;
        if(status === 6){
          _this.status = _flatStatus(data).filter(function(e){
            return _filterData(e);
          });
        }

        if(status === 5 && !_triggerEvent){
          switch(jobType){
            case LRJ_MANAGER.PROCESSIMPORT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_IMPORT', _flatStatusWithSpaces(data));
              break;
            case LRJ_MANAGER.PROCESSPRINT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_PRINT', _flatStatusWithSpaces(data));
              break;
            case LRJ_MANAGER.PROCESSTRANSMITTAL:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_XMIT', _flatStatusWithSpaces(data));
              break;
          }
        }

        if(status === 3 && !_triggerEvent){
          _this.status = _flatStatus(data)
            .filter(function(e){
              return e.match(LRJ_MANAGER.FILTERSDATA.ERROR);
            })
            .map(function(e){
              return 'Error: ' + e.split('Error:')[1];
            });
          _this.showLoading = false;
          longPolling.stop();
        }

        if(status === 0){
          _this.status = _this.messageCancel;
          _this.showLoading = false;
          longPolling.stop();
        }
      }

      /** @private */
      function _process(data){
        var status = data.Status;
        var jobType = data.Command;
        if(status === 5 && !_triggerEvent){
          switch(jobType){
            case LRJ_MANAGER.PROCESSIMPORT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_IMPORT', _flatStatusWithSpaces(data));
              break;
            case LRJ_MANAGER.PROCESSPRINT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_PRINT', _flatStatusWithSpaces(data));
              break;
            case LRJ_MANAGER.PROCESSTRANSMITTAL:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_XMIT', _flatStatusWithSpaces(data));
              break;
          }
        }

        if(status === 3 && !_triggerEvent){
          switch(jobType){
            case LRJ_MANAGER.PROCESSIMPORT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_IMPORT_ERROR', _flatStatus(data));
              break;
            case LRJ_MANAGER.PROCESSPRINT:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_PRINT_ERROR', _flatStatus(data));
              break;
            case LRJ_MANAGER.PROCESSTRANSMITTAL:
              _triggerEvent = true;
              $rootScope.$emit('FINISH_XMIT_ERROR', _flatStatus(data, true));
              break;
          }
        }

        _this.status = _flatStatus(data, (jobType === LRJ_MANAGER.PROCESSTRANSMITTAL)).filter(function(e){
          return _filterData(e);
        });
      }

      /** @private */
      function _showProgress(err, data){
        if(err){
          return console.log(err);
        }

        if(!data.DataObject.Steps){
          return;
        }

        _this.statusPage
          ? _processStatusPage(data.DataObject)
          : _process(data.DataObject);
      }

      /** @private */
      function _flatStatus(data, transmittalProcess){
        var a = _searchProgressList(data);
        if(transmittalProcess){
          var b = [];
          _.each(a, function(e){
            var arr;
            if(e.ProgressStatus.match(/ Error\: /)){
              arr = [e.ProgressStatus];
            }
            else{
              arr = e.ProgressStatus.split('\n');
            }
            _.each(arr, function(el){
              b.push(el);
            });
          });
          return b;
        }
        else{
          var b = [];
          _.each(a, function(e){
            var arr = e.ProgressStatus.split('\n');
            _.each(arr, function(el){
              b.push(el);
            });
          });
          return b;
        }
      }

      /** @private */
      function _searchProgressList(data){
        var a = [];
        _.each(data.Steps, function(e){
          e.ProgressList.forEach(function(el){
            a.push(el);
          });
        });
        return a;
      }

      /** @private */
      function _flatStatusWithSpaces(data){
        var a = [];
        _.each(data.Steps, function(e){
          _.each(e.ProgressList, function(el){
            a.push(el.ProgressStatus);
          });
        });
        return a;
      }

      /** @private */
      function _filterData(e){
        return !e.match(LRJ_MANAGER.FILTERSDATA.ID) && !e.match(LRJ_MANAGER.FILTERSDATA.ERROR) &&
               !e.match(LRJ_MANAGER.FILTERSDATA.FILENAME) && !e.match(LRJ_MANAGER.FILTERSDATA.PRINTPAYERS) &&
               !e.match(LRJ_MANAGER.FILTERSDATA.XMITPAYERS);
      }

      /** @public */
      function _imageProcess(){
        switch(_this.type){
          case LRJ_MANAGER.JOBTYPE.IMPORT:
            return 'lrj-directive-import';
          case LRJ_MANAGER.JOBTYPE.PRINT:
            return 'lrj-directive-print';
          case LRJ_MANAGER.JOBTYPE.XMIT:
            return 'lrj-directive-transmittal';
        }
      }
    }

    /** @private */
    function link(scope, element, attrs){
      element.on('$destroy', function(){
        longPolling.stop();
      });
    }
  }
})();